<div class="modal-title-div d-flex justify-content-between align-items-center py-2 px-4">
  <h4 class="modal-title card-title" id="exampleModalLabel">
    {{'Export File' | translate}}
  </h4>
  <button type="button" class="close" (click)="cancel()"><span aria-hidden="true">×</span></button>
</div>
<mat-dialog-content>
  <div class="row">
    <div class="col-12 col-md-7 risk-checkbox-left-col">
      <div class="lists-container row mb-3">
        <div class="col-12 col-lg-4">
          <div class="list custom-scrollbar">
            <h3 class="bold">
              <mat-checkbox [(ngModel)]="agentAllSelected"
              (change)="selectionChange(agentsList, $event.checked)">{{'Agents' | translate}}</mat-checkbox>
            </h3>
            @for (agent of agentsList; track trackById($index, agent)) {
              <div class="list-item">
                <mat-checkbox (change)="selectionChange(agentsList, $event.checked, 'agentAllSelected')"
                  [(ngModel)]="agent.selected">
                  {{ agent.name }}
                </mat-checkbox>
              </div>
            }

          </div>
        </div>

        <div class="col-12 col-lg-4">
          <div class="list custom-scrollbar">
            <h3 class="bold">
              <mat-checkbox (change)="selectionChange(workersContractorsList, $event.checked)"
              [(ngModel)]="wcAllSelected">{{'Workers & Contractors' | translate}}</mat-checkbox>
            </h3>
            @for (wc of workersContractorsList; track trackByIndex($index)) {
              <div class="list-item">
                <mat-checkbox
                  (change)="selectionChange(workersContractorsList, $event.checked, 'wcAllSelected')"
                  [(ngModel)]="wc.selected">
                  {{ wc.value }}
                </mat-checkbox>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="text-content mt-3 mb-4">
        <p>{{'Included Risk Assessment' | translate}} </p>
      </div>
      <div class="column-label-toggle mb-3">
        <label class="bold d-block mb-1">{{ 'Column Labels' | translate }}</label>
        <mat-radio-group [(ngModel)]="columnLabelMode" (change)="onColumnLabelModeChange()">
          <mat-radio-button value="likelihood">{{ 'Likelihood' | translate }}</mat-radio-button>
          <mat-radio-button value="exposureBand" class="ml-3">{{ 'Exposure Band' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="btn-div">
        <a class="btn modal-footer-btn save-modal-btn w-50" (click)="save()">{{'Export report - PDF (Landscape)' | translate}}</a>
        <a class="btn modal-footer-btn save-modal-btn w-50" (click)="save('portrait')">{{'Export report - PDF' | translate}}</a>
      </div>
      <div class="mt-2">
        <a class="btn modal-footer-btn save-modal-btn w-100" (click)="exportToExcel()">{{'Export Exposure Likelihood - Excel' | translate}}</a>
      </div>
    </div>
    <div class="col-12 col-md-5 risk-assesment-right-col">
      <div class="preview-report" id="risk-assessment-report">
        <div class="logo-date-head mt-2 mb-4 d-flex justify-content-between">
          <div class="company-logo">
            @if (logoUrl) {
              <img [src]="logoUrl" alt="Company Logo" class="tenant-logo">
            }
          </div>

          <span>{{'Report Date' | translate}}: {{currentDate | dateFormat}}</span>
        </div>
        <div class="card-details text-center">
          <h4 class="card-title">{{'Risk Assessments' | translate}}</h4>
          @if (isQualitativeConfigLoaded) {
            <small class="d-block text-muted">
              {{ likelihoodDimensionsLabel }}
            </small>
          }
        </div>

        <div class="table-section">
          @if (!isTableLoading) {
            <div class="table-responsive custom-theme-table custom-scrollbar">
              @if (dataSource.length) {
                <table mat-table class="table outer-bordered-table" [dataSource]="dataSource"
                  >
                  <ng-container matColumnDef="agentName">
                    <th mat-header-cell *matHeaderCellDef>{{'Agent Name' | translate}}</th>
                    <td mat-cell class="bordered-cell" *matCellDef="let element; let i = index"
                      [attr.rowspan]="element.rowSpan">
                      {{element.agentName}}
                    </td>
                  </ng-container>
                  @for (column of likelihoodColumns; track trackByIndex(index); let index = $index) {
                    <ng-container [matColumnDef]="column.id">
                      <th mat-header-cell *matHeaderCellDef [ngStyle]="{'background-color': column.level.Color}">
                        <div>{{ columnHeaders[index] }} </div>
                      </th>
                      <ng-container *matCellDef="let element">
                        <td class="bordered-cell" [ngStyle]="{'background-color': column.level.Color}">
                          <div class="analyte-cell">
                            {{element.healthRiskScores[index].displayValue}}
                          </div>
                        </td>
                      </ng-container>
                    </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
                  class="even-row"></tr>
                </table>
              } @else {
                <div [innerHTML]="noDataError"></div>
              }
            </div>
          }
          @if (isTableLoading) {
            <app-widget-loader
            class="vertically-center-div w-100 justify-content-center"></app-widget-loader>
          }
        </div>

        <div class="text-content mt-2">
          <p>{{'Included Risk Assessment' | translate}}</p>
        </div>

      </div>
    </div>
  </div>
</mat-dialog-content>